import React, { useEffect } from "react";
import { useCallback, useRef, useState } from "react";
import Webcam from "react-webcam";

import { Button, Modal, Ratio } from "react-bootstrap";

const videoConstraints = {
  width: 640,
  height: 480,
  facingMode: "user",
};

function TakePhotoModal({ show, handleClose, onDone, getLangTranslation }) {
  const [loader, setLoader] = useState(true);
  const [newRecordingLoader, setNewRecordingLoadeer] = useState(false);
  const [captured, setCaptured] = React.useState(false);
  const webcamRef = useRef();
  const [imgSrc, setImgSrc] = useState();

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setCaptured(true);
    setImgSrc(imageSrc);
  }, [webcamRef, setImgSrc]);

  const uploadImage = async () => {
    var file = await urltoFile(
      imgSrc,
      Date.now() + "clicked-photo.png",
      base64MimeType(imgSrc)
    ).catch((err) => {
      console.log(err, "here/./");
    });
    if (file) {
      onDone(file);
      setCaptured(false);
    }
  };

  //return a promise that resolves with a File instance
  const urltoFile = (url, filename, mimeType) => {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  };

  //return mime Type of bs64
  const base64MimeType = (encoded) => {
    var result = null;

    if (typeof encoded !== "string") {
      return result;
    }

    var mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

    if (mime && mime.length) {
      result = mime[1];
    }

    return result;
  };

  useEffect(() => {
    if (show)
      setTimeout(() => {
        setLoader(false);
      }, 1000);
  }, [show]);

  useEffect(() => {
    if (newRecordingLoader)
      setTimeout(() => {
        setLoader(false);
        setNewRecordingLoadeer(false);
      }, 800);
  }, [newRecordingLoader]);

  return (
    <Modal
      show={show}
      size="lg"
      className="custom-modal blur-bg"
      centered
      onHide={() => {
        setLoader(true);
        handleClose();
      }}
    >
      <Modal.Header className="border-0 pb-0">
        <div className="border-0 pb-0 d-flex justify-content-between w-100">
          <h6 className="modal-title text-blue-900">{getLangTranslation("TAKE_PHOTOS", "Take photos")}</h6>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              setLoader(true);
              handleClose();
            }}
          ></button>
        </div>
      </Modal.Header>
      <Modal.Body>
          <div className="ratio ratio-5x3 bg-gray">
              <h5 className="text-center"
                style={{
                  display: loader ? "block" : "none",
                }}
              >
                {getLangTranslation("WAIT_FOR_CAMERA_TO_LOAD", "Waiting for Camera to Load")}...
              </h5>
              {!captured ? (
                <Webcam
                  className="rounded-3"
                  style={{ display: loader ? "none" : "block" }}
                  audio={false}
                  ref={webcamRef}
                  height={350}
                  width={460}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints}
                />
              ) : (
                imgSrc && <img src={imgSrc} className="rounded-3" alt="img" />
              )}
            </div>
          <div className="mt-6 d-flex flex-wrap justify-content-center gap-2">
            {!captured ? (
              <button className="btn btn-primary content-200 w-100" onClick={capture}>
                <span className="btn-upper-case">{getLangTranslation("CAPTURE_PHOTO", "Capture photo")}</span>
              </button>
            ) : (
              <>
                <button
                  className="btn btn-outline-primary content-200 w-100"
                  onClick={() => {
                    setLoader(true);
                    setNewRecordingLoadeer(true);
                    setCaptured(false);
                    setImgSrc("");
                  }}
                >
                  <span className="btn-upper-case">{getLangTranslation("CLICK_AGAIN", "Click Again")}</span>
                </button>

                <button className="btn btn-primary content-200 w-100" onClick={uploadImage}>
                  <span className="btn-upper-case">{getLangTranslation("CHILD_TASK_DONE", "Done")}</span>
                </button>
              </>
            )}
          </div>
      </Modal.Body>
    </Modal>
  );
}

export default TakePhotoModal;
